export default function SupportHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9919c3f9c0568d71a9e0d337caebc9ee.jpg"
          alt="Ежемесячное сопровождение сайта"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B4C]/55 via-[#1A2B4C]/45 to-[#1A2B4C]/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-5 sm:px-6 py-20 sm:py-24 text-center">
        <div className="inline-flex items-center gap-2 bg-[#C5A880]/40 border border-[#C5A880]/80 text-[#FFE0A8] px-4 py-2 rounded-full text-xs font-semibold mb-6 font-['Montserrat'] backdrop-blur-sm">
          <i className="ri-shield-check-line"></i>
          Ежемесячное сопровождение
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-['Playfair_Display'] font-bold text-white mb-5 sm:mb-8 leading-tight">
          Ваш сайт работает,<br /> пока вы развиваете бизнес
        </h1>

        <div className="text-sm sm:text-lg md:text-xl text-white/90 mb-8 sm:mb-12 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] text-center space-y-3">
          <p>Комплексная поддержка, SEO-защита и развитие вашего ресурса.</p>
          <p>Мы не даём вашему сайту «устареть» и превращаем его в стабильный источник бесплатных клиентов.</p>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4 justify-center items-stretch sm:items-center">
          <a
            href="#support-form"
            className="group bg-[#C5A880] hover:bg-[#B39770] text-white px-8 py-4 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Подключить сопровождение
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </a>
          <a
            href="#why-support"
            className="group bg-white/20 backdrop-blur-md hover:bg-white/30 text-white border-2 border-white/40 px-8 py-4 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Узнать подробнее
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
